<template>
  <div class="container">
    <div class>
      <div class="mt-100 container-style mb-100">
        <studyFeatureHeader></studyFeatureHeader>
        <div class="p-20">
          <div class="pt-20 mb-22 clearfix epro_qs">
            How would you like your activity to be sent?
          </div>
          <span class="activity-mode">
            <span :class="{ selected: activityMode === 'schedule' }" @click="changeActivityMode('schedule')"><img :src="activityModeIcon['schedule']" width="29" />&nbsp;&nbsp;Scheduled</span>
            <span :class="{ selected: activityMode === 'both' }" @click="changeActivityMode('both')"><img :src="activityModeIcon['both']" width="58" />&nbsp;&nbsp;Both scheduled and on-demand</span>
            <span :class="{ selected: activityMode === 'onDemand' }" @click="changeActivityMode('onDemand')"><img :src="activityModeIcon['onDemand']" width="29" />&nbsp;&nbsp;On-demand only</span>
          </span>
          <div :class="{ 'activity-mode-opacity': activityMode === 'onDemand' }" v-if="activityMode">
            <div class="fw-500 fs-24">
              Select when you would like your participants to take this ePRO
            </div>
            <div class="pt-20">Schedule by</div>
            <schedulerComponent :options="{ validateFor: 'epro', activityMode: activityMode }"></schedulerComponent>
          </div>
          <div class="pt-20">
            <span class="back_link" v-on:click="goBack()"> <i class="fa fa-chevron-left" aria-hidden="true"></i> Back </span>
          </div>
        </div>
        <div class="footerStyle">
          <div class="container">
            <div class="row">
              <button class="btn br-25 disable-btn mr-10" v-on:click="skipForNow()">
                Skip for now
              </button>
              <button class="btn nextBtn br-25" v-on:click="validateScheduler()">
                Save and Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from "toastr";
import _ from "lodash";
import studyFeatureHeader from "../common/study-features-header";
import schedulerComponent from "../common/scheduler";

const MODE_ICON = {
  schedule: {
    selected: "static/img/selected-scheduled-activity-icon.svg",
    unselected: "static/img/scheduled-activity-icon.svg"
  },
  both: {
    selected: "static/img/selected-scheduled-and-on-demand-activity.svg",
    unselected: "static/img/scheduled-and-on-demand-activity.svg"
  },
  onDemand: {
    selected: "static/img/selected-on-demand-activity-icon.svg",
    unselected: "static/img/on-demand-activity-icon.svg"
  }
};

export default {
  name: "scheduler",
  data() {
    return {
      studyId: null,
      surveyId: null,
      studyData: {},
      surveyData: {},
      milestones: [],
      frequencies: [
        { type: "daily", title: "Daily", days: 1 },
        { type: "weekly", title: "Weekly", days: 7 },
        { type: "biweekly", title: "Every 2 Weeks", days: 15 },
        { type: "monthly", title: "Monthly", days: 30 },
        { type: "biannually", title: "Bi-annually", days: 180 },
        { type: "annually", title: "Annually", days: 360 }
      ],
      questionAnswers: [],
      daysOccurrenceArr: [],
      scheduler: {
        type: "milestone",
        milestones: [],
        frequency: {},
        startDay: null,
        endDay: null,
        completionWindow: null,
        reminders: [{}],
        allowMultipleTimes: false,
        allowUntillDuration: false
      },
      activitySchedulingMode: "",
      activityModeIcon: {
        schedule: MODE_ICON.schedule.unselected,
        both: MODE_ICON.both.unselected,
        onDemand: MODE_ICON.onDemand.unselected
      },
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT
    };
  },
  components: {
    studyFeatureHeader,
    schedulerComponent
  },
  computed: {
    schedulerObjChanged() {
      return this.$store.getters.getSchedulerObjData;
    },
    activityMode: {
      get: function() {
        return this.activitySchedulingMode;
      },
      set: function(mode) {
        this.activitySchedulingMode = mode;
      }
    }
  },
  watch: {
    schedulerObjChanged: {
      handler(val, oldValue) {
        if (val.validatedFor === "epro") {
          if (oldValue.autoSave) {
            this.addScheduler(val.schedulerObj, oldValue.autoSave);
          } else {
            this.addScheduler(val.schedulerObj);
          }
        }
      }
    }
  },
  mounted() {
    this.studyId = this.$route.params.studyId;
    this.surveyId = this.$route.params.surveyId;
    this.getStudyDetails();
    this.getSurveyDetails();
    this.startAutoSave();
  },
  methods: {
    goBack() {
      window.history.back();
    },
    skipForNow() {
      const selectedFeatures = this.$store.getters.getSelectedFeatures;
      const featureIndex = _.findIndex(selectedFeatures, ["route", "epros"]);
      if (featureIndex === selectedFeatures.length - 1) {
        this.$router.push({ name: "features-library-final" });
      } else {
        this.$router.push({
          name: selectedFeatures[featureIndex + 1].route,
          params: { studyId: this.studyId }
        });
      }
    },
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(
        response => {
          this.studyData = response.body;
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    getSurveyDetails() {
      this.$api.getSurveyDetailsFact(this.studyId, this.surveyId).then(
        response => {
          this.surveyData = response.body;
          if (response.body.scheduler) {
            this.activityMode = this.surveyData.scheduler.activitySchedulingMode;
          } else {
            this.activityMode = "schedule";
          }
          this.setActivityModeIcon(this.activityMode);
          this.$store.dispatch("setSurveyDetailsAction", response.body);
          if (this.surveyData.questions && this.surveyData.questions.length > 0) {
            this.timeToComplete = this.surveyData.timeToComplete;
            this.introQuestions = _.filter(response.body.questions, o => o.type && o.type.toLowerCase() === "surveyinstruction");
            this.questionAnswers = _.filter(response.body.questions, o => o.type && o.type.toLowerCase() !== "surveyinstruction");
          }
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the survey details");
        }
      );
    },
    validateScheduler(autoSave = false) {
      if (!autoSave) {
        this.$store.dispatch("addSchedule", { validateFor: "epro" });
      } else {
        this.$store.dispatch("addSchedule", {
          validateFor: "epro",
          autoSave: autoSave
        });
      }
    },
    addScheduler(scheduleObj, autoSave = false) {
      this.$api.postSchedulingFact(this.studyId, scheduleObj).then(
        () => {
          if (!autoSave) {
            toastr.success("Scheduling completed successfully");
            this.$router.push({
              name: "epros",
              params: { studyId: this.studyId, surveyId: this.surveyId }
            });
          }
        },
        error => {
          if (!autoSave) {
            toastr.error(error.body ? error.body.message : "Error while the scheduling the survey");
          }
        }
      );
    },
    changeActivityMode(mode) {
      this.activitySchedulingMode = mode;
      this.setActivityModeIcon(mode);
    },
    setActivityModeIcon(mode) {
      for (const prop in this.activityModeIcon) {
        if (prop === mode) {
          this.activityModeIcon[prop] = MODE_ICON[prop]["selected"];
        } else {
          this.activityModeIcon[prop] = MODE_ICON[prop]["unselected"];
        }
      }
    },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        this.validateScheduler(true);
      }, this.autoSaveElementTimeout);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name != "epros") {
      this.validateScheduler(true);
    }
    setTimeout(() => {
      next();
    }, 100);
  },
  beforeDestroy() {
    this.stopAutoSave();
  }
};
</script>

<style scoped lang="scss">
.bg-green {
  background-color: #2ecc71 !important;
}

.bg-red {
  background-color: #ff7171 !important;
}

.container-style {
  border-radius: 2px;
  background-color: #ffffff;
  color: #666769;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

.example {
  margin: 40px 40px 20px 40px;
}
.example-content {
  padding: 20px 40px 20px 40px;
}
.example-header {
  padding: 20px 80px 10px 80px;
  font-weight: bold;
}

.form-control {
  border-radius: 2px;
}

.epro_qs {
  font-weight: 600;
  color: #666769;
}

.activity-mode {
  margin-bottom: 22px;
  display: inline-block;
  & span {
    padding: 16px 28px 16px 11px;
    margin-right: 13px;
    background: #fff;
    border-radius: 3px;
    border: solid 1px #d3dfe4;
    font-size: 15px;
    &.selected {
      background: #34537d;
      color: #fff;
    }
    &:hover {
      cursor: pointer;
    }
  }
}

.activity-mode-opacity {
  visibility: hidden;
}
</style>
